<div
  class="custom-dropdown"
  [class.disabled]="disabled"
  (click)="toggleDropdown()"
>
  <div [id]="dropdownId" class="dropdown-selected">
    {{ selectedOption[displayKey] || placeholder || "Select an option" }}
  </div>
  @if (!disabled) {
    <img
      class="dropdown-indicator"
      [class.open]="dropdownOpen"
      src="assets/images/down-direction.svg"
      alt="open dropdown"
    />
  }
  @if (dropdownOpen) {
    <ul class="dropdown-options" #dropdownMenu>
      @if (searchable) {
        <div class="search">
          <img
            src="/assets/images/search.svg"
            alt="search"
            class="search-icon"
          />
          <input
            class="search-input"
            type="text"
            placeholder="Search..."
            [(ngModel)]="searchTerm"
            (keyup)="onSearchChange()"
            (keydown.enter)="onEnterPress()"
            (click)="$event.stopPropagation()"
          />
        </div>
      }
      @for (option of searchResults; track option[trackKey]) {
        <li
          class="dropdown-option"
          [class.selected]="option[trackKey] === selectedOption[trackKey]"
          (click)="selectOption(option, $event)"
        >
          <img
            class="img"
            [class.selectedImg]="option[trackKey] === selectedOption[trackKey]"
            src="assets/images/tick-active.svg"
            alt="selected"
          />
          {{ option[displayKey] }}
        </li>
      }
    </ul>
  }
</div>
